import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CMSProvider } from './context/CMSContext';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Forside from './pages/Forside';
import OmOs from './pages/OmOs';
import Koeletransport from './pages/Koeletransport';
import Kontakt from './pages/Kontakt';
import Ydelse from './pages/Ydelse';
import Reference from './pages/Reference';
import Referencer from './pages/Referencer';
import Error404 from './pages/Error404';
import Error403 from './pages/Error403';

function App() {
  return (
    <CMSProvider>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen bg-brand-dark text-gray-100 antialiased">
        {/* Header */}
        <Header />

        {/* Main Content Area */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Forside />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/koeletransport" element={<Koeletransport />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/ydelse" element={<Ydelse />} />
            <Route path="/reference" element={<Reference />} />
            <Route path="/referencer" element={<Referencer />} />
            <Route path="/403" element={<Error403 />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </CMSProvider>
  );
}

export default App;
